import React from 'react'
import PropTypes from 'prop-types'
import { Card, Col, Row, Space, Tag, Typography } from 'antd'
import { interactionLabel } from './utils'

// Which companies this deployment can route to at all.
//
// Above the cards rather than inside them, because it answers a question that is not per-service:
// "is Bachs set up here yet?" A gateway that is NOT configured is why a route further down the
// page shows a fallback warning, so seeing the two together saves the operator guessing.
const GatewayStrip = ({ gateways }) => (
  <Row gutter={[16, 16]}>
    {(gateways || []).map(gateway => (
      <Col xs={24} sm={12} lg={8} key={gateway.key}>
        <Card size="small">
          <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <Space>
              <Typography.Text strong>{gateway.label || gateway.key}</Typography.Text>
              {gateway.configured ? (
                <Tag color="green">Set up</Tag>
              ) : (
                // Not an error: a gateway with no keys here is the normal state of one we have
                // not signed up for yet. It is only a problem once a route names it.
                <Tag>Not set up here</Tag>
              )}
              {gateway.canRefund ? <Tag color="blue">Refunds</Tag> : null}
            </Space>
            <div style={{ opacity: 0.65 }}>
              {Object.keys(gateway.rails || {}).length
                ? Object.entries(gateway.rails)
                    .map(([rail, interaction]) => `${rail}: ${interactionLabel(interaction)}`)
                    .join(' · ')
                : 'No rails'}
            </div>
          </Space>
        </Card>
      </Col>
    ))}
  </Row>
)

GatewayStrip.propTypes = {
  gateways: PropTypes.array
}

export default GatewayStrip
